import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Main',
    main: [
      {
        state: 'admin-dashboard',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'addCat',
        name: 'CATEGORIES',
        type: 'link',
        icon: 'ti-align-justify'
      },
      {
        state: 'admin-users',
        name: 'Users',
        type: 'link',
        icon: 'ti-user'
      },
      {
        state: 'admin-banners',
        name: 'ADVERTISEMENTS',
        type: 'link',
        icon: 'ti-shopping-cart'
      },
/*       {
        state: 'admin-notification',
        name: 'Notification',
        type: 'link',
        icon: 'ti-bell'
      } */
    ],
  },
   {
    label: 'Manage',
    main: [
      {
        state: 'admin-setting',
        name: 'SETTING',
        type: 'link',
        icon: 'ti-settings',
      },
/*       {
        state: 'admin-coupons',
        name: 'Coupons',
        type: 'link',
        icon: 'ti-medall'
      }, */
      {
        state: 'admin-notification',
        name: 'Notification',
        type: 'link',
        icon: 'ti-bell'
      },
      {
        state: 'admin-chats',
        name: 'Support',
        type: 'link',
        icon: 'ti-comments-smiley'
      },
/*       {
        state: 'admin-rest-stats',
        name: 'Restaurant Stats',
        type: 'link',
        icon: 'ti-stats-up'
      } */
    ]
  }, 

];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}
